import React, {useEffect} from 'react';
import {useRecoilState, useRecoilValue} from "recoil";
import {answerState, surveyDataState,} from "../../state/globalState";
import RadioType from "../common/RadioType";

/**
 * 설문 문항 컴포넌트
 */
const Survey17 = (props) => {
    const [answer, setAnswer] = useRecoilState(answerState);

    // 조건부 질문 비활성화 시 응답 초기화 (예외: 32, 61, 77, 83, 102는 유지)
    useEffect(() => {
        const resets = {};
        const exceptSteps = new Set([32, 61, 77, 83, 102]);

        const resetRange = (start, end, isVisible) => {
            if (!isVisible) {
                for (let i = start; i <= end; i++) {
                    if (!exceptSteps.has(i)) {
                        const key = `step_${i}`;
                        if (answer[key] !== undefined && answer[key] !== '') {
                            resets[key] = undefined;
                        }
                    }
                }
            }
        };

        const resetSteps = (steps, isVisible) => {
            if (!isVisible) {
                steps.forEach(i => {
                    const key = `step_${i}`;
                    if (answer[key] !== undefined && answer[key] !== '') {
                        resets[key] = undefined;
                    }
                });
            }
        };

        // 1. 주택임차차입금 (step 31 하위: 32~47)
        resetRange(32, 47, answer['step_31'] === '1');
        // 1-1. 다른 임차주택 (48~59)
        resetRange(48, 59, answer['step_31'] === '1' && answer['step_46'] === '1' && answer['step_47'] === '0');

        // 2. 장기주택저당차입금 (step 60 하위)
        // step 61은 예외 (초기화 제외)
        // step_126 = "아니오"(0)이면 비세대주 미거주 → step_62, step_64 미노출/초기화 (step_65~73은 유지)
        const isStep60Yes = answer['step_60'] === '1';
        const isHouseholder = answer['step_61'] === '1';
        const isNonHouseholder = answer['step_61'] === '0';
        const isResiding = answer['step_126'] === '1';
        const isNotResiding = answer['step_126'] === '0';

        resetSteps([63], isStep60Yes && !(isResiding && !isHouseholder));
        resetSteps([64], isStep60Yes && (isHouseholder || isResiding));
        resetRange(65, 73, isStep60Yes);
        resetSteps([126], isStep60Yes && isNonHouseholder);
        resetSteps([62], isStep60Yes && isNonHouseholder && isResiding);
        resetSteps([74], isStep60Yes && (isHouseholder || isResiding) && answer['step_72'] === '1' && answer['step_73'] === '1');

        // 3. 청약저축 (step 75 하위: 76~79)
        resetRange(76, 79, answer['step_75'] === '1');
        resetSteps([119], answer['step_75'] === '1' && answer['step_78'] === '0');
        resetSteps([80], answer['step_75'] === '1' && answer['step_78'] === '1' && answer['step_79'] === '0');

        // 4. 주택청약종합저축 (step 81 하위: 82~85, 127)
        resetRange(82, 85, answer['step_81'] === '1');
        resetSteps([127], answer['step_81'] === '1' && answer['step_83'] === '0');

        // 5. 장기집합투자증권저축 (step 87 하위: 88~94)
        resetRange(88, 94, answer['step_87'] === '1');

        // 6. 청년형 장기집합투자증권저축 (step 95 하위: 96~100)
        resetRange(96, 100, answer['step_95'] === '1');

        // 7. 월세액 세액공제 (step 101 하위: 102~110)
        resetRange(102, 110, answer['step_101'] === '1');

        if (Object.keys(resets).length > 0) {
            setAnswer(prev => ({ ...prev, ...resets }));
        }
    }, [
        answer['step_31'], answer['step_46'], answer['step_47'],
        answer['step_60'], answer['step_61'], answer['step_126'], answer['step_72'], answer['step_73'],
        answer['step_75'], answer['step_78'], answer['step_79'],
        answer['step_81'], answer['step_83'],
        answer['step_87'],
        answer['step_95'],
        answer['step_101']
    ]);

    const getSurveyComponent = (start, end) => {
        const surveyComponent = [];
        for ( let i = start; i <= end; i++){
            surveyComponent.push(<RadioType step={i}/>);
        }
        return surveyComponent
    };
    return (
        <>
            {/* 1. 주택임차차입금 원리금상환액 소득공제 관련 공제금액 */}
            <RadioType step={31}/>
            {answer['step_31'] === '1' && getSurveyComponent(32, 47)}
            {(answer['step_31'] === '1' && answer['step_46'] === '1'&& answer['step_47'] === '0') && <div style={{background:"#eaf3e9", width:"fit-content", padding:"15px 0"}}>{ getSurveyComponent(48, 59) }</div>}
            {/* 2. 장기주택저당차입금 이자 소득공제 관련 공제금액 */}
            <RadioType step={60}/>

            {/* step 61은 항상 먼저 노출 */}
            {answer['step_60'] === '1' && <RadioType step={61}/>}
            {/* step 61 = 아니오(0) 인 경우 바로 step 126 노출 */}
            {(answer['step_60'] === '1' && answer['step_61'] === '0') && <RadioType step={126}/>}
            {(answer['step_60'] === '1' && answer['step_61'] === '0' && answer['step_126'] === '1') && <RadioType step={62}/>}
            {/* step 60 = 예(1) 인 경우에만 이후 문항 노출 */}
            {/* 비세대주+거주이면 step_63 노출 */}
            {(answer['step_60'] === '1' && answer['step_61'] === '0' && answer['step_126'] === '1') && <RadioType step={63}/>}
            {/* 세대주 또는 비세대주+거주이면 step_64 노출. 비세대주+미거주이면 step_64 미노출 */}
            {(answer['step_60'] === '1' && (answer['step_61'] === '1' || answer['step_126'] === '1')) && <RadioType step={64}/>}
            {/* step_65~73은 step_60=예이면 항상 노출 */}
            {answer['step_60'] === '1' && getSurveyComponent(65, 73)}
            {(answer['step_60'] === '1' && answer['step_72'] === '1' && answer['step_73'] === '1') && <RadioType step={74}/>}

            {/* 3. 청약저축(장기주택마련저축) 납입액 소득공제 관련 공제금액 */}
            <RadioType step={75}/>
            {answer['step_75'] === '1' && getSurveyComponent(76, 79)}
            {(answer['step_75'] === '1' && answer['step_78'] === '0') && <RadioType step={119}/>}
            {( answer['step_75'] === '1' && answer['step_78'] === '1' && answer['step_79'] === '0') && <RadioType step={80}/>}
            {/* 4. 주택청약종합저축 납입액 소득공제 관련 공제금액 */}
            <RadioType step={81}/>
            {answer['step_81'] === '1' && getSurveyComponent(82, 85)}
            {/* step 81 = '1'이고, step 83 = '0'일 때 step 127 노출 */}
            {(answer['step_81'] === '1' && answer['step_83'] === '0') && <RadioType step={127}/>}
            {/* 5. 투자조합 출자 등에 대한 소득공제 관련 공제금액 */}
            <RadioType step={86}/>
            {/* 6. 장기집합투자증권저축 납입액에 대한 소득공제 관련 공제금액 */}
            <RadioType step={87}/>
            {answer['step_87'] === '1' && getSurveyComponent(88, 94)}
            {/* 7. 청년형 장기집합투자증권저축 납입액에 대한 소득공제 관련 공제금액 */}
            <RadioType step={95}/>
            {answer['step_95'] === '1' && getSurveyComponent(96, 100)}
            {/* 8. 월세액 세액공제  관련 공제금액 */}
            <RadioType step={101}/>
            {answer['step_101'] === '1' && getSurveyComponent(102, 110)}
        </>
    );
};

export default Survey17;
